import $ from 'jquery';

class CartRequests {
  constructor() {
    this.processRequestInterval = 500;
    this.processing = false;

    this.interval = setInterval(() => this._postRequests(), this.processRequestInterval);
    this.requests = [];
  }

  addItem(data) {
    const request = this._findAddItemRequest(data);
    const sanitizedData = data;

    this.requests = this.requests.filter(r => r !== request);

    sanitizedData.quantity = Math.max(0, sanitizedData.quantity);

    this.requests.push({
      type: 'add',
      data,
      timestamp: Math.floor(Date.now()),
    });

    // Immediately process adding an item
    this._postRequests(true);
  }

  changeItem(data) {
    const request = this._findChangeItemRequest(data);
    const sanitizedData = data;

    this.requests = this.requests.filter(r => r !== request);

    sanitizedData.quantity = Math.max(0, sanitizedData.quantity);

    this.requests.push({
      type: 'change',
      data,
      timestamp: Math.floor(Date.now()),
    });

    // Immediately process removing an item
    if (sanitizedData.quantity === 0) {
      this._postRequests(true);
    }
  }

  updateNote(note) {
    this.requests = this.requests.filter(r => r.type !== 'update');

    this.requests.push({
      type: 'update',
      data: { note },
      timestamp: Math.floor(Date.now()),
    });
  }

  unload() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  _triggerStartLoadingEvents() {
    $(window).trigger('cart-loading-start');
  }

  _triggerFinishLoadingEvent(newCart, oldCart, error) {
    const newItems = newCart.items.filter((newItem) => {
      for (let i = 0; i < oldCart.items.length; i++) {
        const oldItem = oldCart.items[i];

        if (newItem.key === oldItem.key && newItem.quantity !== oldItem.quantity) {
          return true;
        }

        if (newItem.key === oldItem.key) {
          return false;
        }
      }

      return true;
    });

    $(window).trigger(
      'cart-loading-finish',
      {
        cart: newCart,
        newItems,
        error,
      },
    );
  }

  _handleError(error) {
    $(window).trigger('cart-loading-error', {
      error,
    });
  }

  _shouldPostRequests() {
    return (
      !this.processing
      && this.requests.length
      && (
        Math.floor(Date.now()) - this.requests[this.requests.length - 1].timestamp
        >= this.processRequestInterval
      )
    );
  }

  _postRequests(force = false) {
    if (!force && !this._shouldPostRequests()) {
      return;
    }

    const requestsToProcess = this.requests;
    let originalCart = null;

    this.requests = [];
    this.processing = true;

    this._triggerStartLoadingEvents();

    let $deferred = $.Deferred().resolve();

    $deferred = $deferred
      .then(() => $.get({ url: '/cart.js', dataType: 'json' }))
      .then((cart) => {
        originalCart = cart;
      });

    requestsToProcess.forEach((request) => {
      let deferredRequest = null;

      if (request.type === 'add') {
        deferredRequest = () => $.post({
          url: '/cart/add.js',
          data: request.data,
          dataType: 'json',
        });
      }

      if (request.type === 'change') {
        deferredRequest = () => $.post({
          url: '/cart/change.js',
          data: request.data,
          dataType: 'json',
        });
      }

      if (request.type === 'update') {
        deferredRequest = () => $.post({
          url: '/cart/update.js',
          data: request.data,
          dataType: 'json',
        });
      }

      $deferred = $deferred.then(deferredRequest);
    });

    $deferred = $deferred
      .then(() => $.get({ url: '/cart.js', dataType: 'json' }))
      .then(newCart => this._triggerFinishLoadingEvent(newCart, originalCart))
      .catch((error) => {
        this._handleError(error.responseJSON.description);

        $.get({ url: '/cart.js', dataType: 'json' })
          .then(newCart => this._triggerFinishLoadingEvent(newCart, originalCart, error));
      })
      .always(() => {
        this.processing = false;
      });
  }

  _findAddItemRequest(data) {
    let request = null;

    this.requests.forEach((r) => {
      if (r.type === 'add') {
        if (r.data.id === data.id) {
          request = r;
        }
      }
    });

    return request;
  }

  _findChangeItemRequest(data) {
    let request = null;

    this.requests.forEach((r) => {
      if (r.type === 'change') {
        if (r.data.id === data.id) {
          request = r;
        }
      }
    });

    return request;
  }
}

export default new CartRequests();
